export default __webpack_public_path__ + "static/media/sec4.1c3d3695.jpeg";